import { addToastMessage, removeToastMessage } from '../components/ToastMessageQueue';

const ToastHelper = {
  addToastMessage,
  removeToastMessage,
};

export default ToastHelper;
